module.exports = {
    LOGIN_RESULT: 'login_result',
    MATCH_STARTED: 'match_started',
    BET_STARTED: 'bet_started',
    BET_FINISHED: 'bet_finished',
    BET_PLACED: 'bet_placed',
    NUM_PLAYERS_CHANGED: 'num_players_changed',
    QUESTION_ASKED: 'QUESTION_ASKED',
    ASK_FINISHED: 'ASK_FINISHED',
    RECEIVE_QUESTIONS: 'RECEIVE_QUESTIONS',
    RECEIVE_ANSWERS: 'RECEIVE_ANSWERS',
    SAVED_QUESTION: 'SAVED_QUESTION',
    SAVED_ANSWER: 'SAVED_ANSWER',
    DELETED_ANSWER: 'DELETED_ANSWER',
    DELETED_QUESTION: 'DELETED_QUESTION',
    SAVED_MATCH: 'SAVED_MATCH',
    RECEIVE_MATCHES: 'RECEIVE_MATCHES',
    DELETED_MATCH: 'DELETED_MATCH',
    MATCH_STOPPED: 'MATCH_STOPPED',
    ANSWER_GIVEN: 'ANSWER_GIVEN',
    ANSWER_PROCESSED: 'ANSWER_PROCESSED',
    CHART_UPDATED: 'CHART_UPDATED',
    POSITION_UPDATED: 'POSITION_UPDATED',
    PLAYER_STATUS: 'PLAYER_STATUS',
    UNKNOWN_TOKEN: 'UNKNOWN_TOKEN',
    RECEIVED_CHAT_MESSAGE: 'RECEIVED_CHAT_MESSAGE',
    RECEIVE_QUESTION_GAME : 'RECEIVE_QUESTION_GAME',
    SAVED_QUESTION_GAME: 'SAVED_QUESTION_GAME',
    BEEN_MODERATED: 'BEEN_MODERATED',
    PLAYER_MODERATED:'PLAYER_MODERATED',
    PLAYER_ADDED:'PLAYER_ADDED',
    PLAYER_REMOVED:'PLAYER_REMOVED',
    BANNED_PLAYERS_SENT: 'BANNED_PLAYERS_SENT',
    STREAMING_STARTED: 'STREAMING_STARTED',
    STREAMING_STOPPED: 'STREAMING_STOPPED',
    LOGGED_OUT: 'LOGGED_OUT',
    USER_LOGGED_OUT: 'USER_LOGGED_OUT',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    USERS_RECEIVED: 'USERS_RECEIVED',
    SAVED_EXP_USER: 'SAVED_EXP_USER',
    SAVED_NEW_USERNAME: 'SAVED_NEW_USERNAME',
    EXP_USER_RECEIVED: 'EXP_USER_RECEIVED',
    USER_CALLED: 'USER_CALLED',
    CALL_CONFIRMED: 'CALL_CONFIRMED',
    CALL_CLOSED : 'CALL_CLOSED',
    CALL_REFUSED: 'CALL_REFUSED',
    RECEIVE_BETS: 'RECEIVE_BETS',
    RECEIVE_USER_POINTS: 'RECEIVE_USER_POINTS',
    CHANGED_USER_POINTS: 'CHANGED_USER_POINTS',
    RECEIVE_CURRENTQUESTIONID: 'RECEIVE_CURRENTQUESTIONID',
    RECEIVE_USERANSWERS : 'RECEIVE_USERANSWERS',
    RECEIVE_QUESTION_GAMES : 'RECEIVE_QUESTION_GAMES',
    CHAT_ENABLED: 'CHAT_ENABLED',
    CHAT_DISABLED: 'CHAT_DISABLED',
    USER_DELETED: 'USER_DELETED',
    PASSWORD_UPDATED : 'PASSWORD_UPDATED',
    AUTOSTREAM_STARTED: 'AUTOSTREAM_STARTED',
    AUTOSTREAM_STOPPED: 'AUTOSTREAM_STOPPED',
    NUMBER_OF_CHATTERS_SENT: 'NUMBER_OF_CHATTERS_SENT',
    NUMBER_OF_CHATTERS_SETTED: 'NUMBER_OF_CHATTERS_SETTED',
    USERS_LIMIT_NUMBER_SENT: 'USERS_LIMIT_NUMBER_SENT',
    USERS_LIMIT_NUMBER_SETTED:'USERS_LIMIT_NUMBER_SETTED',
    GAME_RESTORED: 'GAME_RESTORED',
    SNAPSHOT_DELETED: 'SNAPSHOT_DELETED',
    TEMPORARY_USER_DELETED: 'TEMPORARY_USER_DELETED'
}


// WEBPACK FOOTER //
// ./src/events/ServerToClient.js